import { useEffect, useState } from "react";

import { Team, useGetAllTeamsQuery } from "../redux/slices";

type useGetCustomTeamsType = {
  customTeams: Team[];
  loading: boolean;
};

export interface useGetCustomTeamsProps {
  searchTerm: string;
  sort: { sortValue: CustomTeamSortValues; sortDirection: string };
}

export enum CustomTeamSortValues {
  name = "name",
  noOfPlays = "noOfPlays",
}

export const useGetCustomTeams = ({ searchTerm, sort }: useGetCustomTeamsProps): useGetCustomTeamsType => {
  const [customTeams, setCustomTeams] = useState<Team[]>([]);

  const { data: teamsOrig, isLoading: loadingAllTeams } = useGetAllTeamsQuery();

  useEffect(() => {
    if (teamsOrig) {
      const customTeams = teamsOrig?.filter((team) => team.isEnterpriseTeam === false) || [];
      const filteredTeams = searchTerm
        ? customTeams.filter((team) => team.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : customTeams;

      const sortedTeams = sort.sortValue
        ? [...filteredTeams].sort((a, b) => {
            if (sort.sortDirection === "asc") {
              return a[sort.sortValue] > b[sort.sortValue] ? 1 : -1;
            } else {
              return a[sort.sortValue] < b[sort.sortValue] ? 1 : -1;
            }
          })
        : filteredTeams;

      setCustomTeams(sortedTeams);
    }
  }, [searchTerm, sort, teamsOrig]);

  return { customTeams, loading: loadingAllTeams };
};
